import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { SafeUrlPipe } from '../../core/pipes/safe-url.pipe';

@Component({
  selector: 'app-video-modal',
  standalone: true,
  imports: [CommonModule, NzModalModule, NzButtonModule, SafeUrlPipe],
  template: `
    <nz-modal
      [nzClosable]="true"
      [nzTitle]="videoUrlTemplate"
      [(nzVisible)]="visible"
      [nzFooter]="modalFooterTemplate"
      nzWidth="700px"
      nzClassName="video-modal"
      nzCentered
      (nzOnCancel)="onClose()"
      *ngIf="videoUrl">
      <ng-template #videoUrlTemplate>
        <ng-container>
          <iframe
            [src]="videoUrl | safeUrl"
            width="100%"
            height="450"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen>
          </iframe>
        </ng-container>
      </ng-template>

      <ng-template #modalFooterTemplate>
        <div
          class="modal-footer"
          style="display: flex; justify-content: flex-end;">
          <button nz-button nzType="default" (click)="onClose()">Back</button>
        </div>
      </ng-template>
    </nz-modal>
  `,
})
export class VideoModalComponent {
  @Input() visible = false;
  @Input() videoUrl?: string;
  @Output() visibleChange = new EventEmitter<boolean>();

  onClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
